export default "__VITE_ASSET__kuUBHllJ__"